import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':workOrderId'}/productionData`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/productionData`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}/productionData`;
